import dynamic from 'next/dynamic';
import { ThemeProvider } from 'styled-components';

import { themes } from '@vimeo/iris/themes';

import { withViewer } from '../wrapper/withViewer';
import { ROUTE_PATH } from './constants';
import { ReactRouterLayout } from './ReactRouterLayout';

const ShowcasePageComponent = dynamic(() => import('./ShowcasePage'), { ssr: false });

const ShowcaseEmbedWrapper = () => (
  <ThemeProvider theme={themes.light}>
    <ReactRouterLayout path={ROUTE_PATH}>
      <ShowcasePageComponent />
    </ReactRouterLayout>
  </ThemeProvider>
);

export default withViewer(ShowcaseEmbedWrapper, { hideSpinner: true });
